import { Route, Routes as RouterRoutes } from "react-router-dom";
import About from "./views/About/About";
import Contact from "./views/Contact/Contact";
import MapView from "./views/Map/MapView";
import SiteDetail from "./views/SiteDetail/SiteDetail";
import Sites from "./views/Sites/Sites";
import Windows from "./views/Windows/Windows";

export const routeList = [
  {
    path: "/",
    element: <MapView />,
    title: "Darkskies | Find dark skies you can stay under",
  },
  {
    path: "/sites",
    element: <Sites />,
    title: "Sites | Darkskies",
  },
  {
    path: "/sites/:id",
    element: <SiteDetail />,
    title: "Site | Darkskies",
  },
  {
    path: "/windows",
    element: <Windows />,
    title: "Viewing windows | Darkskies",
  },
  {
    path: "/about",
    element: <About />,
    title: "About | Darkskies",
  },
  {
    path: "/contact",
    element: <Contact />,
    title: "Contact | Darkskies",
  },
];

export const AppRoutes = () => (
  <RouterRoutes>
    {routeList.map((route) => (
      <Route key={route.path} path={route.path} element={route.element} />
    ))}
  </RouterRoutes>
);
